const SubBannerSimple: React.FC = () => {
  const currentYear = new Date().getFullYear()
  return (
    <div className="sb-main">
      <div className="sticky top-0 flex h-auto w-auto flex-col justify-start">
        <div className="border-theme mt-[15px] rounded-2xl border">
          <div className="flex flex-col items-start gap-[7px] p-[15px]">
            <h1 className="flex text-xl font-bold">
              Subscribe to{' '}
              <span className="exile-regular flex items-center px-[5px]">
                Y?
              </span>
              now!
            </h1>
            <p className="pb-[5px] text-base font-light tracking-tighter">
              To unlock amazing features, zero ads and to experience our newest
              features.{' '}
              <span className="font-bold">
                ( Clicking the below will actually route you to X... )
              </span>
            </p>
            <button
              onClick={() => {
                if (
                  confirm('Are you sure you want to move away from this page?')
                ) {
                  window.location.href = 'https://www.x.com/'
                }
              }}
              className="bgd-blue flex cursor-pointer items-center justify-center rounded-full px-[20px] py-[10px] text-sm text-white"
            >
              Join now!
            </button>
          </div>
        </div>
        <div className="border-theme mt-[15px] rounded-2xl border">
          {' '}
          <div className="flex flex-col items-start">
            <h1 className="px-[15px] py-[10px] text-xl font-bold">
              Who to follow
            </h1>
            <p className="text-sub px-[15px] pb-[15px] text-sm font-light tracking-tighter">
              This feature is not yet available...
            </p>
          </div>
        </div>
        {/* this is some sort of a band-aid solution for now. */}
        <h1 className="opacity-0">
          footerfooterfooterfooterfooterfooterfooterfooter
        </h1>
        <footer className="text-sub mt-[5px] h-[100px] w-full px-[20px] text-sm tracking-tighter">
          @ {currentYear}{' '}
          <a target="_blank" href="https://www.eabcdev.com">
            eabcdev.com
          </a>
        </footer>
      </div>
    </div>
  )
}

export default SubBannerSimple
